import {
  createLazyContext,
  useLazyContextProvider,
  useRequiredContext,
} from "@redotech/react-util/context";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { RedoMerchantClientContext } from "@redotech/redo-merchant-app-common/client/context";
import { getCustomerTagsOfTeam } from "@redotech/redo-merchant-app-common/client/customer-tags";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { CustomerTagWithId } from "@redotech/redo-model/customer";
import { SupportPermissions } from "@redotech/redo-model/permissions";
import { memo, ReactNode } from "react";

export const CustomerTagsContext = createLazyContext<CustomerTagWithId[]>();

export const CustomerTagsService = memo(function CustomerTagsService({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const client = useRequiredContext(RedoMerchantClientContext);

  const team = useRequiredContext(TeamContext);

  const hasSupportPermission = useHasPermission(
    SupportPermissions.VIEW_SUPPORT,
  );
  const loadState = useLazyContextProvider(async (signal) => {
    if (!hasSupportPermission) {
      return [];
    }
    const teamTags = await getCustomerTagsOfTeam(
      client,
      { teamId: team._id },
      signal,
    );
    const tagIds = teamTags.map((tag) => {
      return {
        tagId: tag._id,
        name: tag.name,
        pillTheme: tag.pillTheme,
        source: tag.source,
      };
    });
    return tagIds.sort((a, b) => a.name.localeCompare(b.name));
  });

  return (
    <CustomerTagsContext.internalContext.Provider value={loadState}>
      {children}
    </CustomerTagsContext.internalContext.Provider>
  );
});
